module.exports = __webpack_public_path__ + "static/img/bg_mountains_dark_gradient.830201f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/bg_mountains_dark_gradient.png
// module id = 43UH
// module chunks = 1